import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { NgScrollbar } from 'ngx-scrollbar';
import {
  IMessagingMember,
  MESSAGING_VIEWS,
  MessagingUsersTableAction,
} from '../../../store/messages/messages.interfaces';
import { CurrentUserService } from '../../../services/current-user.service';
import { getMessagingView } from '../../../store/messages/messages.selectors';
import { AppState } from '../../../store/app-state';
import { OPTIONS } from '@app/framework/constants/options-list.constants';

@Component({
  selector: 'app-messaging-users-table',
  templateUrl: './messaging-users-table.component.html',
  styleUrls: ['./messaging-users-table.component.scss'],
  imports: [CommonModule, NgScrollbar],
})
export class MessagingUsersTableComponent implements OnInit {
  @Input() listItems: string[] = [];
  @Input() disabledActionList: OPTIONS[] = [];
  @Output() selectedOption = new EventEmitter<MessagingUsersTableAction>();

  @Input() usersRelated: IMessagingMember[];
  @Input() discussionMembers: IMessagingMember[];
  @Output() closeDropdown = new EventEmitter();

  selectedView$ = this.store.select(getMessagingView);
  MESSAGING_VIEWS = MESSAGING_VIEWS;

  constructor(
    private userService: CurrentUserService,
    private store: Store<AppState>,
  ) {}

  ngOnInit(): void {}

  isSelected(user: IMessagingMember) {
    return !!this.discussionMembers.find((selectedUser) => selectedUser.user_id === user.user_id);
  }

  /**
   * Handling close and open events is done by its associated directive.
   * Component only detects if the user interaction is inside the component or not.
   */
  @HostListener('document:click')
  onClick() {
    this.closeDropdown.emit(true);
  }

  isUserAdmin() {
    return this.discussionMembers.find(
      (selected) => selected.user_id === this.userService.data.id && selected.is_admin,
    );
  }

  isSelfUser(user: IMessagingMember) {
    return user.user_id === this.userService.data.id;
  }

  isAddedByCurrentUser(user: IMessagingMember): boolean {
    if (!user.added_by) {
      return false;
    }
    return this.isSelfUser(user.added_by as IMessagingMember);
  }

  optionSelected(item: MessagingUsersTableAction) {
    this.selectedOption.emit(item);
  }
}
